<div style="background: #F5F5F5; padding: 16px;">
  <div class="row page-title-bar" style="margin-bottom: 16px;">
    <div class="medium-12 title">Announcements</div>
  </div>
  <div class="row"  style="background: #FFFFFF;">
    <div class="column large-12 medium-12 small-12" *ngIf="org == 'trialtaxplaniq' || org == 'test-taxplaniq' || org == 'stag-taxplaniq'" style="font-size: 14px !important;">
      <div class="float-right pointer" style="margin: 10px 10px;color: #1570EF;display: inline-flex;" (click)="createNewAnnouncement()">
        <i class="material-icons">add</i><span style="position: relative;top: 2px;">Create a new Announcement</span>
      </div>
    </div>
    <div class="column large-12 medium-12 small-12" [ngClass]="(org != 'trialtaxplaniq' && org != 'test-taxplaniq' && org != 'stag-taxplaniq') ? 'mt-3' : ''">
      <div class="row no-hover client-todos tax-strategy client-plans badge-tables" style="height: 66vh;overflow-y: scroll;padding: 0">
        <div class="medium-12 large-12 tpiq-paginated-table invoices scenarios">
          <table style="margin-top: 0 !important;font-size: 15px;color: #333333;">
            <thead>
            <tr>
              <th *ngFor="let column of columns">
                <span>{{column.title}}</span>
              </th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <ng-template [ngIf]="announcementsList && announcementsList.length == 0">
              <tr class="text-center">
                <td [attr.colspan]="columns.length">
                  <div class="callout text-center">
                    <p>No Results Found.</p>
                  </div>
                </td>
              </tr>
            </ng-template>
            <ng-template [ngIf]="announcementsList && announcementsList.length > 0">
              <tr class="pointer" *ngFor="let row of announcementsList;let i=index">
                <td *ngFor="let col of columns;let idx=index" (click)="navigateToAnnouncementPage(row)">
                  <div class="pointer table-col" *ngIf="col.name != 'description'">
                    {{row[col.name]}}
                  </div>
                  <div class="pointer text-ellipsis richText-truncate" *ngIf="col.name == 'description'">
                    <div [innerHTML]="row[col.name]"></div>
                  </div>
                </td>
                <td>
                  <div class='badge-tooltip' *ngIf="org == 'trialtaxplaniq' || org == 'test-taxplaniq' || org == 'stag-taxplaniq'">
                    <a class='action' data-action='delete'><span class='todo-del' (click)="deleteAnnouncement(row)"><i class="material-icons delete">delete</i></span></a>
                  </div>
                </td>
              </tr>
            </ng-template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="reveal['addOrEditAnnouncement']">
  <div class="reveal-overlay" [ngClass]="{'tpiq-reveal': reveal['addOrEditAnnouncement']}">
  </div>
  <div class="reveal tax-strategy-reveal" style="padding: 0; border: none; width: 50%;" [ngClass]="{'tpiq-reveal': reveal['addOrEditAnnouncement']}">
    <div style="height: 50px; padding: 15px; color: #333333;">
      <span class="float-left" *ngIf="org == 'trialtaxplaniq' || org == 'test-taxplaniq' || org == 'stag-taxplaniq'">{{editMode? 'Update Announcement': 'Create a New Announcement'}} </span>
      <span class="float-left" *ngIf="org != 'trialtaxplaniq' && org != 'test-taxplaniq' && org != 'stag-taxplaniq'">View Announcement</span>
      <span class="float-right pointer" (click)="hideReveal('addOrEditAnnouncement')">X</span>
    </div>
    <div style="padding: 0 15px;">
      <hr style="margin: 0;"/>
    </div>
    <div class="body" style="padding: 15px;">
      <app-create-or-update-announcement [editMode]="editMode" [announcementId]="announcementId" (onCancelCreateOrUpdateOfAnnouncement)="hideReveal('addOrEditAnnouncement')"
                                       (onCreationOrUpdateOfAnnouncement)="refreshListOfAnnouncements()"></app-create-or-update-announcement>

    </div>
  </div>
</div>
